// removed by extract-text-webpack-plugin
module.exports = {"variable-width":"Slider__variable-width__3_VZk","slick-slide":"Slider__slick-slide__1sxa9","center":"Slider__center__3PsDx","slick-center":"Slider__slick-center__3YjsS","content":"Slider__content__ZILKD","image":"Slider__image__1RuAJ","slick-loading":"Slider__slick-loading__3sFLn","slick-slider":"Slider__slick-slider__29HUH","slick-dots":"Slider__slick-dots__3zI75","slick-thumb":"Slider__slick-thumb__BxpE0","slick-active":"Slider__slick-active__3KonT","slick-vertical":"Slider__slick-vertical__2z2hw"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Slider/Slider.css
// module id = 124
// module chunks = 0